/* * @Author: 曹俊杰 * @Date: 2024-10-11 11:53:19 * @Last Modified by: mikey.zhaopeng *
@Last Modified time: 2025-05-18 19:32:06 */购买菜单
<template>
  <div class="dialog">
    <el-dialog :visible.sync="dialogVisible" @close="close" append-to-body>
      <div class="dialogContent">
        <div class="top">订单支付</div>

        <div class="zongjia">
          <div class="lebel">实付金额</div>
          <div class="value">
            ¥
            <span>{{ priceTotal | priceFormat }}</span>
          </div>
        </div>
        <div class="chanpin">
          <div class="item" v-for="(item, index) in chanpinList" :key="index">
            <div class="label">{{ item.name }}</div>
            <div class="value">¥ {{ item.price | priceFormat }}</div>
          </div>
        </div>
        <div class="zhifu">支付方式</div>
        <div class="">
          <paymentMethod v-model="paymentMethodStyle" :showZhifubao="showZhifubao" :yuezhifujia="priceTotal"/>
        </div>
        <div class="btns">
          <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit" size="mini">确 定</el-button>
        </div>
      </div>
      <!-- <div class="top">订单支付</div>
      <div class="dialog__title" style="background-color: #f3f6f8">订单信息</div>
      <div class="dialog__item">
        <div class="dialog__item__l">{{ parme.name }}：</div>
        <div class="dialog__item__r">¥ {{ parme.price | priceFormat }}</div>
      </div>
      <div class="dialog__item">
        <div class="dialog__item__l">总金额：</div>
        <div class="dialog__item__r blue">¥ {{ parme.price | priceFormat }}</div>
      </div>
      <div class="dialog__title" style="margin-top: 20px; background-color: #f3f6f8">
        支付方式
      </div>
      <div class="dialog__item">
        <div class="dialog__item__l">
          余额支付(当前余额：¥ {{ parme.balance | priceFormat }})：
        </div>
        <div class="dialog__item__r red">¥ {{ parme.price | priceFormat }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getSubmit" size="mini">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import paymentMethod from "@/components/paymentMethod/paymentMethod";
export default {
  props: {
    showZhifubao: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    paymentMethod,
  },
  data() {
    return {
      dialogVisible: false,
      chanpinList: [],
      paymentMethodStyle: 1,
    };
  },
  computed: {
    priceTotal() {
      let total = 0;
      this.chanpinList.forEach((item) => {
        total += item.price;
      });
      return total;
    },
  },
  methods: {
    show({ chanpinList }) {
      this.chanpinList = chanpinList;
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },
    onSubmit() {
      this.$emit("onSubmit", this.paymentMethodStyle, this.chanpinList);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  .blue {
    color: #0062ff;
  }

  .red {
    color: #ff0d0d;
  }

  ::v-deep.el-dialog {
    background: #f3f6f8;
  }

  &__title {
    color: #262626;
    font-family: "Noto Sans SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 34px;
    background: #fff;
    padding: 0 16px;
  }

  &__item {
    color: #262626;
    font-family: "Noto Sans SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 50px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__l {
    }

    &__r {
    }
  }
}
.dialogContent {
  background: #ffffff;
  .top {
    height: 58px;

    font-size: 18px;
    font-weight: 500;
    color: #262626;
    padding: 0 16px;
    display: flex;
    align-items: center;
  }
  .zongjia {
    height: 64px;
    display: flex;
    margin: 0 16px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px dashed #eeeeee;
    .label {
      color: #cccccc;
    }
    .value {
      color: #ff0d0d;
      font-size: 16px;
      span {
        font-size: 30px;
        font-weight: bold;
      }
    }
  }
  .chanpin {
    padding-top: 10px;
    padding-bottom: 20px;
    .item {
      padding: 0 16px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .zhifu {
    padding: 0 16px;
    height: 50px;
    display: flex;
    align-items: center;
  }
  .btns {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 16px;
  }
}
</style>
